export default __webpack_public_path__ + "static/media/wakatime.0dffa8e2.svg";